import axiosInstance from "../axiosInstance";

const BASE_URL = process.env.REACT_APP_API_URL;
const STAGE = process.env.REACT_APP_API_STAGE;

export const getListProfileUpdates = async () => {
    try {
        const response = await axiosInstance.get(
          `${BASE_URL}v1/${STAGE}/dashboard/profile-updates`
        );
        return response.data;
      } catch (error) {
        throw error;
      }
}

export const confirmListProfileUpdates = async (payload: any) => {
  try {
      const response = await axiosInstance.post(
        `${BASE_URL}v1/${STAGE}/dashboard/profile-updates-confirm`, payload
      );
      return response.data;
    } catch (error) {
      throw error;
    }
}

